/**
 * Download Menu Component
 * Provides export options for Canvas documents
 */

import { useTranslation } from "react-i18next"

import { Download, FileText, FileType } from "@/components/icons"
import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"

type DownloadMenuProps = {
  onDownloadWord: (useTemplate: boolean) => void
  disabled?: boolean
  hasTemplate?: boolean
}

export function DownloadMenu({
  onDownloadWord,
  disabled = false,
  hasTemplate = false,
}: DownloadMenuProps) {
  const { t } = useTranslation()

  return (
    <DropdownMenu>
      <Tooltip>
        <TooltipTrigger asChild>
          <DropdownMenuTrigger asChild>
            <Button
              className="disabled:opacity-100"
              disabled={disabled}
              size="sm"
              variant="outline"
            >
              <Download className="mr-2 h-4 w-4" />
              {t("canvas.download", "Download")}
            </Button>
          </DropdownMenuTrigger>
        </TooltipTrigger>
        <TooltipContent>
          <p>{t("canvas.download", "Download")}</p>
        </TooltipContent>
      </Tooltip>
      <DropdownMenuContent align="end">
        {hasTemplate ? (
          <>
            <DropdownMenuItem className="cursor-pointer" onClick={() => onDownloadWord(false)}>
              <FileText className="mr-2 h-4 w-4" />
              <span>{t("canvas.download_word_standard", "Save as Word (Standard)")}</span>
            </DropdownMenuItem>
            <DropdownMenuItem className="cursor-pointer" onClick={() => onDownloadWord(true)}>
              <FileType className="mr-2 h-4 w-4" />
              <span>{t("canvas.download_word_template", "Save as Word (Company Template)")}</span>
            </DropdownMenuItem>
          </>
        ) : (
          <DropdownMenuItem className="cursor-pointer" onClick={() => onDownloadWord(false)}>
            <FileText className="mr-2 h-4 w-4" />
            <span>{t("canvas.download_word", "Save as Word")}</span>
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
